import React, { useState, useEffect } from "react";
import { Form, Input, Button, Card, message as messageAntd, Radio, Select } from "antd";
import { SendOutlined } from "@ant-design/icons";
import PageTemplate from "../../../template/PageTemplate";
import { Colors } from "configs";

import { NotificationRequest, CourseNotificationRequest } from "services/notification";

import { getAllCourses } from "services/course";

const { TextArea } = Input;
const { Option } = Select;

export const SendNotification = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [notificationType, setNotificationType] = useState("massa");

  const [courses, setCourses] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(false);

  useEffect(() => {
    const getCourses = async () => {
      setLoadingCourses(true);
      try {
        const list = await getAllCourses();
        setCourses(list.data);
      } catch (error) {
        console.error("Erro ao carregar cursos", error);
      } finally {
        setLoadingCourses(false);
      }
    };

    getCourses();
  }, []);

  const onFinish = async (values) => {
    setLoading(true);

    try {
      const { type, courseId, title, message } = values;

      if (type === "massa") {
        await NotificationRequest({ title, message });
      } else if (type === "curso") {
        await CourseNotificationRequest({ courseId: courseId, title, message });
      }

      messageAntd.success("Notificação disparada com sucesso!");

      form.resetFields(["title", "message", "courseId"]);
    } catch (error) {
      messageAntd.error("Erro ao disparar a notificação. Tente novamente.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageTemplate title="Disparar Notificação">
      <div style={{ display: "flex", justifyContent: "center", padding: "40px" }}>
        <Card style={{ width: "100%", maxWidth: 500, boxShadow: "0 4px 12px rgba(0,0,0,0.05)" }} bordered={false}>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            requiredMark="optional"
            initialValues={{ type: "massa" }}
          >
            <Form.Item name="type" label="Tipo de Envio">
              <Radio.Group
                buttonStyle="solid"
                size="large"
                style={{ display: 'flex' }}
                onChange={(e) => setNotificationType(e.target.value)}
              >
                <Radio.Button value="massa" style={{ flex: 1, textAlign: 'center' }}>
                  Todos os Alunos
                </Radio.Button>
                <Radio.Button value="curso" style={{ flex: 1, textAlign: 'center' }}>
                  Por Curso
                </Radio.Button>
              </Radio.Group>
            </Form.Item>

            {notificationType === "curso" && (
              <Form.Item
                label="Selecione o Curso"
                name="courseId"
                rules={[
                  { required: true, message: "Por favor, selecione um curso." }
                ]}
              >
                <Select
                  size="large"
                  placeholder="Escolha o curso..."
                  loading={loadingCourses}
                  showSearch
                  optionFilterProp="children"
                >
                  {courses?.map(course => (
                    <Option key={course.id} value={course.id}>
                      {course.ds_titulo}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            )}

            <Form.Item
              label="Título da Notificação"
              name="title"
              rules={[
                { required: true, message: "Por favor, insira o título." },
                { max: 50, message: "O título deve ter no máximo 50 caracteres." },
              ]}
            >
              <Input placeholder="Ex: 📖 Novo Tópico Liberado!" size="large" />
            </Form.Item>

            <Form.Item
              label="Mensagem"
              name="message"
              rules={[
                { required: true, message: "Por favor, insira a mensagem." },
                { max: 150, message: "Limite de 150 caracteres para melhor leitura no app." },
              ]}
            >
              <TextArea placeholder="Ex: O tópico já está disponível para estudo." rows={4} size="large" showCount maxLength={150} />
            </Form.Item>

            <Form.Item style={{ marginTop: 32, marginBottom: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                icon={<SendOutlined />}
                loading={loading}
                block
                style={{
                  backgroundColor: Colors.primary,
                  borderColor: Colors.primary,
                  color: Colors.white,
                }}
              >
                Enviar Push Notification
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </PageTemplate>
  );
};
